// store
import { getDealRefId, updateDealRefId } from '../../activeDeal/selector';
import type { DealXgSocketProcessor } from '../types';

/**
 * Keeps the active deal's `dealRefId` in sync with the incoming DealXG, so downstream consumers
 * always read the latest reference id.
 */
export const syncDealRefId: DealXgSocketProcessor = (store, action) => {
    const newDealRefId: string = action.payload?.data?.coxAutoReferences?.dealRefId ?? '';
    if (getDealRefId(store.getState()) !== newDealRefId) {
        store.dispatch(updateDealRefId(newDealRefId));
    }
};
